/*
 * - Stores paths for the Project service endpoints
 */

const serviceRoot = 'api/Project/';

export const ProjectEndpoints = {
  // Queries ---------------------------------------------------------------------------------------
  getSharedContacts: () => `${serviceRoot}getSharedContacts`,
  getExistingProjectsBasicInfo: () => `${serviceRoot}getExistingProjectsBasicInfo`,
  getProjectLocationData: () => `${serviceRoot}getProjectLocationData`,
  getAllowedRequestTypes: () => `${serviceRoot}getAllowedRequestTypes`,

  // Mutations -------------------------------------------------------------------------------------
};
